/** The text a strength is described with; the values are the words the app's feedback copy keys use. */
export enum StrengthTextLevel {
  OUTSTANDING = 'outstanding',
  EXCELLENT = 'excellent',
  GOOD = 'good'
}

/** The text a weakness is described with; the values are the words the app's feedback copy keys use. */
export enum WeaknessTextLevel {
  FOCUS_AREA = 'focusArea',
  POTENTIAL = 'potential',
  IDEA = 'idea'
}

/** The status label shown beside a strength. */
export enum FeedbackStatusLevel {
  EXCELLENT = 'excellent',
  GOOD = 'good',
  NEEDS_WORK = 'needsWork'
}
